import APIRequest from './APIRequest'
import APIResponse from './APIResponse'

export const APIEvents = {
  request: 'request',
  response: 'response',
} as const

export interface EventListenerFunctions {
  [APIEvents.request]: (
    request: APIRequest<any, unknown, unknown>,
    middlewareOptions?: any,
  ) => void
  [APIEvents.response]: (
    response: APIResponse<any, any, any>,
    middlewareOptions?: any,
  ) => void
}
